<template>
  <div class="drop_container">
    <button
      class="justify-between"
      @click="toggleDropdown"
    >
      <span
        class="text_left"
        :class="{ grey: !selectedItem }"
        >{{ selectedItem || props.placeholder }}</span
      >
      <img
        :src="
          require('@/assets/components/FigmaDDSSlicePNGa7e3954ad9f1ed3c78e67b7e1ca8bfc9.png')
        "
        alt="Dropdown arrow"
        class="img_right"
        :class="{ transform_180: isOpen }"
      />
    </button>
    <div
      v-if="isOpen"
      class="selected_container"
    >
      <div
        v-for="(item, index) in props.options"
        :key="index"
        class="selected_item"
        @click="selectItem(item)"
      >
        {{ typeof item === "object" && item !== null ? item.label : item }}
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  onUnmounted,
  defineEmits,
  defineProps,
  defineOptions,
  watch,
} from "vue"

defineOptions({
  name: "Dropdown",
})

const emit = defineEmits(["selection-change"])
// 选项数据通过props传入
// options:['S1A', 'S1B'] or [{ label: "S1A", value: "S1A" }]
const props = defineProps({
  options: {
    type: Array,
    required: true,
    description: "下拉选项数组",
  },
  defineOption: {
    type: String,
    required: false,
    description: "默认选中项",
    default: "",
  },
  placeholder: {
    type: String,
    required: true,
    description: "默认占位文本",
  },
})

// Reactive state
const isOpen = ref(false)
const selectedItem = ref(null)

// Methods
const toggleDropdown = () => {
  isOpen.value = !isOpen.value
}

const selectItem = (item) => {
  if (typeof item === "object" && item !== null) {
    selectedItem.value = item.label
    emit("selection-change", item.value)
  } else {
    selectedItem.value = item
    emit("selection-change", item)
  }
  isOpen.value = false
}

// Click outside handler
const handleClickOutside = (e) => {
  if (!e.target.closest(".drop_container")) {
    isOpen.value = false
  }
}

// Lifecycle hooks
onMounted(() => {
  document.addEventListener("click", handleClickOutside)
})

watch(
  [() => props.options, () => props.defineOption],
  () => {
    if (!props.options || !props.defineOption) {
      selectedItem.value = null
      return
    }

    const hasMatch = props.options.some((element) => {
      if (typeof element === "object" && element !== null) {
        return element.label === props.defineOption
      }
      return element === props.defineOption
    })

    selectedItem.value = hasMatch ? props.defineOption : null
  },
  { immediate: true }
)

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside)
})
</script>

<style scoped>
.drop_container {
  position: relative;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  width: 10.06vw;
  height: 1.67vw;
  border-left: 1px solid rgba(209, 209, 209, 1);
  border-top: 1px solid rgba(209, 209, 209, 1);
  border-right: 1px solid rgba(209, 209, 209, 1);
  border-bottom: 0.06vw solid rgba(97, 97, 97, 1);
}

.text_left {
  width: 8.2vw;
  text-align: left;
  padding-left: 0.5vw;
  font-size: 0.73vw;
  color: #000;
  line-height: 1.6vw;
}

.grey {
  color: rgba(112, 112, 112, 1);
}

.img_right {
  width: 1vw;
  height: 1vw;
  margin-top: 0.25vw;
}

.transform_180 {
  transform: rotate(180deg);
}

.selected_container {
  position: absolute;
  width: 10vw;
  height: auto;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(209, 209, 209, 1);
  border-radius: 4px;
  top: 1.92vw;
  z-index: 999;
}

.selected_item {
  cursor: pointer;
  width: 10vw;
  height: 1.4vw;
  line-height: 1.4vw;
  margin-top: 0.1vw;
  padding-left: 0.5vw;
  font-size: 0.73vw;
}
</style>
